import React from "react";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Select } from "@danishagro/shared/src/components/atoms/Select/Select.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import S from "./Pagination.module.scss";

interface PaginationProps {
    page: number;
    pageSize: number;
    totalItems: number;
    onChangePage: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
    page,
    pageSize,
    totalItems,
    onChangePage,
}: PaginationProps) => {
    const { getDictionaryString } = useTranslations();
    const [totalPages, setTotalPages] = React.useState(Math.ceil(totalItems / pageSize));

    React.useEffect(() => {
        setTotalPages(Math.ceil(totalItems / pageSize));
    }, [totalItems, pageSize]);

    const paginationOptions = Array.from({ length: totalPages }, (_, i) => ({
        label: `${getDictionaryString("profile.orderHistory.pagination")} ${i + 1} / ${totalPages}`,
        value: (i + 1).toString(),
    }));

    return (
        <div className={S.paginationWrapper}>
            <DA_Button
                className={S.paginationButton}
                onClick={() => onChangePage(page - 1)}
                disabled={page === 1}
                iconRight={false}
                icon={DA_IconNames.ChevronLeft}
                title={getDictionaryString("profile.orderHistory.pagination.prev")}
            />

            <DA_Select
                className={S.pageSelect}
                ariaLabel={getDictionaryString("profile.orderHistory.pagination.gotoPage")}
                options={paginationOptions}
                value={page.toString()}
                onChange={(option) => onChangePage(Number(option.value))}
            />

            <DA_Button
                className={S.paginationButton}
                onClick={() => onChangePage(page + 1)}
                disabled={page === totalPages}
                iconRight={true}
                icon={DA_IconNames.ChevronRight}
                title={getDictionaryString("profile.orderHistory.pagination.next")}
            />
        </div>
    );
};
